import { Component } from '@angular/core';
import { BaseNumericPropertyViewModel } from '../../../view-models/base-type/base-numeric-property-view-model';
import { NNumericPropertyViewModel } from '../../../view-models/base-type/nnumeric-property-view-model';
import { NumericMaskSettings } from './base/base-numeric-box/base-numeric-box.component';
import { NewBasePropertyTextBox } from './new-base-property-text-box';

@Component({
    template: ''
})

export abstract class BaseNumericPropertyTextBox extends NewBasePropertyTextBox<number|null|''> {
    override propertyViewModel: BaseNumericPropertyViewModel;
    
    calculateMaxValue(decimalDigits: number, integerDigits: number): number {
        const integerDigitsString = "9".repeat(integerDigits);
        let decimalDigitsString = "";
        if (decimalDigits > 0) {
            decimalDigitsString = BaseNumericPropertyViewModel.getDecimalSeparator() + "9".repeat(decimalDigits);
        }
        let maxValue = parseFloat(integerDigitsString + decimalDigitsString);
        if (this.propertyViewModel.isDecimal === false) {
            if (maxValue > BaseNumericPropertyViewModel.MAX_INTEGER_VALUE) {
                maxValue = BaseNumericPropertyViewModel.MAX_INTEGER_VALUE
            }
        }
        return maxValue;
    }

    calculateMinValue(decimalDigits: number, integerDigits: number): number {
        const integerDigitsString = "9".repeat(integerDigits);
        let decimalDigitsString = "";
        if (decimalDigits > 0) {
            decimalDigitsString = BaseNumericPropertyViewModel.getDecimalSeparator() + "9".repeat(decimalDigits);
        }
        let minValue = parseFloat(integerDigitsString + decimalDigitsString) * -1;
        if (this.propertyViewModel.isDecimal === false) {
            if (minValue < BaseNumericPropertyViewModel.MIN_INTEGER_VALUE) {
                minValue = BaseNumericPropertyViewModel.MIN_INTEGER_VALUE
            }
        }
        return minValue;
    }

    protected getMaskSettings(): NumericMaskSettings {
        const nullable = this.propertyViewModel instanceof NNumericPropertyViewModel;
        const digits = BaseNumericPropertyViewModel.getDecimalDigits(this.propertyViewModel.propertyName, this.propertyViewModel.integerLimit, this.propertyViewModel.decimalLimit);
        let integerDigits = BaseNumericPropertyViewModel.getIntegerDigits(this.propertyViewModel.propertyName, this.propertyViewModel.integerLimit, this.propertyViewModel.decimalLimit);
        if (this.propertyViewModel.isDecimal === false && integerDigits > BaseNumericPropertyViewModel.MAX_INTEGER_LENGTH) {
            integerDigits = BaseNumericPropertyViewModel.MAX_INTEGER_LENGTH;
        } 
        
        let max = this.propertyViewModel.maxValue != null ? this.propertyViewModel.maxValue : this.calculateMaxValue(digits, integerDigits);
        const min = this.propertyViewModel.minValue != null ? this.propertyViewModel.minValue : this.calculateMinValue(digits, integerDigits);

        return {
            nullable,
            decimalLimit: digits,
            integerLimit: integerDigits,
            useThousandSeparator: this.propertyViewModel.useThousandSeparator,
            min,
            max,

            // alias: 'numeric',
            // nullable,
            // positionCaretOnClick: 'none' as any,
            // allowMinus: true,
            // allowPlus: false,
            // unmaskAsNumber: true,
            // radixPoint: BaseNumericPropertyViewModel.getDecimalSeparator(),
            // groupSeparator: this.propertyViewModel.useThousandSeparator ? BaseNumericPropertyViewModel.getThousandSeparator() : '',
            // SetMaxOnOverflow: false,
            // showMaskOnHover: false,
            // digits,
            // digitsOptional: true,
            // min,
            // max,
            // placeholder: nullable ? '' : '0',
            // rightAlign: true,
            // clearMaskOnLostFocus: true
        };
    }
}
